export default "__VITE_ASSET__BV0OSWUq__"